import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { DevisStatut, IDevisResponse } from 'src/app/shared/models/devis';
import { DevisService } from './devis.service';
import { DevisDialogComponent } from './devis-dialog/devis-dialog.component';
import { DevisCreateDialogComponent } from './devis-create-dialog/devis-create-dialog.component';
import { DevisRetourDialogComponent } from './devis-retour-dialog/devis-retour-dialog.component';
import { DevisViewDialogComponent } from './devis-view-dialog/devis-view-dialog.component';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { CurrentUserService } from 'src/app/shared/services/current-user.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { ThemeService } from 'src/app/shared/services/theme.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { UserProfile } from 'src/app/shared/models/user-profile';
import { IApplication } from 'src/app/shared/models/fiche-expression-besoin';
import {ApplicationSettingsService} from '../application-settings/application-settings.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Sort } from '@angular/material/sort';
import { DevisDocumentMergeService } from './devis-document-merge.service';

import * as fileSaver from 'file-saver';

import { DevisPdfService } from './devispdf.service';
import { IDevisCollaborateur } from 'src/app/shared/models/devis-collaborateur';
import { CollaborateurService } from '../collaborateurs-list/collaborateur.service';
import { DevisCollaborateurService } from './devis-collaborateurs/devis-collaborateur.service';
import { DevisRefuseDialogComponent } from './devis-validation/devis-refuse-dialog/devis-refuse-dialog.component';
import { DevisValidateDialogComponent } from './devis-validation/devis-validate-dialog/devis-validate-dialog.component';


@Component({
  selector: 'app-devis-management',
  templateUrl: './devis-management.component.html',
  styleUrls: ['./devis-management.component.less']
})
export class DevisManagementComponent implements AfterViewInit {

  devisList: MatTableDataSource<IDevisResponse>;
  displayedColumns: string[] = [
    'devisReference', 'montantTotal', 'beneficiaire',
    'febDivisionDemandeurNom', 'febProjetNom',
    'febDateDemarrage', 'febDuree',
    'devisStatut', 'devisCreatedAt', 'actions'
  ];
  readonly DevisStatut = DevisStatut;
    readonly adminRole = 'Administrateur';
  readonly managerCdsRole = 'Manager CDS';
  readonly serviceManagerRole = 'Service Manager';


  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private devisService: DevisService,
    public authenticationService: AuthenticationService,
    private currentUserService: CurrentUserService,
    private dialogService: DialogService,
     private devisDocumentMergeService: DevisDocumentMergeService,
    private dialog: MatDialog,
      private devisPdfService: DevisPdfService,
    public theme: ThemeService,
    private snackbarService: SnackbarService,
      private _liveAnnouncer: LiveAnnouncer,
        private applicationSettingsService: ApplicationSettingsService,
         private devisCollaborateurService: DevisCollaborateurService,
    private collaborateurService: CollaborateurService,
  ) {
    this.devisList = new MatTableDataSource();
    this.loadDevis();
  }

     openErrorSnackBar(message: string) {
    this.snackbarService.openSnackBar(message, 'error-snack-bar');
  }

  openSuccessSnackBar(message: string) {
    this.snackbarService.openSnackBar(message);
  }

  loadDevis(): void {
    const profile = this.authenticationService.getUser()?.profile;
    switch (profile) {
      case UserProfile.ADMIN:
        this.devisService.getAll().subscribe({
          next: data => { this.devisList.data = data; },
          error: () => { this.snackbarService.openSnackBar('Erreur lors du chargement des devis', 'error-snack-bar'); }
        });
        break;
      
      case UserProfile.SERVICE_MANAGER:
        this.devisService.getAll().subscribe({
          next: data => { this.devisList.data = data; },
          error: () => { this.snackbarService.openSnackBar('Erreur lors du chargement des devis', 'error-snack-bar'); }
        });
        break;
      
      case UserProfile.MANAGER_CDS:
        this.devisService.getAll().subscribe({
          next: data => { this.devisList.data = data; },
          error: () => { this.snackbarService.openSnackBar('Erreur lors du chargement des devis', 'error-snack-bar'); }
        });
        break;
      
      case UserProfile.CP_CDS:
        this.devisService.getByApplications(this.currentUserService.getUserApplications()).subscribe({
          next: data => { this.devisList.data = data; },
          error: () => { this.snackbarService.openSnackBar('Erreur lors du chargement des devis', 'error-snack-bar'); }
        });
        break;
      
      case UserProfile.CP_SNCF:
        this.devisService.getByApplicationsAndNonStatus(this.currentUserService.getUserApplications(), DevisStatut.CREE).subscribe({
          next: data => { this.devisList.data = data; },
          error: () => { this.snackbarService.openSnackBar('Erreur lors du chargement des devis', 'error-snack-bar'); }
        }); 
        break;
      }

  }

  announceSortChange(sortState: Sort) {
  if (sortState.direction) {
    this._liveAnnouncer.announce(
      `Tri ${sortState.direction === 'asc' ? 'ascendant' : 'descendant'}`
    );
  } else {
    this._liveAnnouncer.announce('Tri réinitialisé');
  }
}


  getUserApplications(): IApplication[] {
    return this.currentUserService.getUserApplications();
  }

  ngAfterViewInit(): void {
  this.devisList.sort = this.sort;

  this.sort.active = 'devisCreatedAt';
  this.sort.direction = 'desc';

  this.sort.sortChange.emit({
    active: this.sort.active,
    direction: this.sort.direction
  });

  this.devisList.sortingDataAccessor = (item, property) => {
    switch (property) {

      case 'devisCreatedAt':
        return item.devisCreatedAt
          ? new Date(item.devisCreatedAt).getTime()
          : 0;

      case 'febDateDemarrage':
        return item.devisDateDemarrageGo
          ? new Date(item.devisDateDemarrageGo).getTime()
          : 0;

      case 'montantTotal':
        return item.devisMontantTotal ?? 0;

      case 'febDuree':
        return item.devisDuree ?? 0;

      default:
        return (item as any)[property];
    }
  };
}


  applyFilter(event: Event): void {
    this.devisList.filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
  }

  openDialog(devis: IDevisResponse): void {
    const dialogRef = this.dialog.open(DevisDialogComponent, {
      width: '950px',
      maxWidth: '98vw',
      maxHeight: '92vh',
      data: devis
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadDevis();
      }
    });
  }

  openViewDialog(devis: IDevisResponse): void {
    this.dialog.open(DevisViewDialogComponent, {
      width: '880px',
      maxWidth: '98vw',
      maxHeight: '94vh',
      data: devis
    });
  }

  canDelete(devis: IDevisResponse): boolean {
    if(devis.devisStatut === DevisStatut.ARCHIVE){
      if (this.authenticationService.isUserAdmin()) return true;
    }
      return false ; 
    
  }

  deleteDevis(devis: IDevisResponse): void {
    this.dialogService.openConfirmDialog('Supprimer le devis "' + (devis.devisReference ?? devis.devisId) + '" ?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.devisService.delete(devis.devisId).subscribe({
            next: () => {
              this.snackbarService.openSnackBar('Devis supprimé avec succès');
              this.devisList.data = this.devisList.data.filter(d => d.devisId !== devis.devisId);
            },
            error: () => { this.snackbarService.openSnackBar('Erreur lors de la suppression', 'error-snack-bar'); }
          });
        }
      });
  }

  isCdcOrAdmin(): boolean {
    const profile = this.authenticationService.getUser()?.profile;
   
    return this.authenticationService.isUserAdmin()
      || profile === UserProfile.MANAGER_CDS
      || profile === UserProfile.CP_CDS;
  }

  isAdminOrSNCF(){
    const profile = this.authenticationService.getUser()?.profile;
    return this.authenticationService.isUserAdmin()
      || profile === UserProfile.CP_SNCF
      || profile === UserProfile.SERVICE_MANAGER;
  }


  canSendToSncf(devis: IDevisResponse): boolean {

     if(!this.isDevisComplet(devis))
      return false ; 
 
    return this.isCdcOrAdmin()
      && devis.devisStatut === DevisStatut.CREE;
  }
 
 
  

 isDevisComplet(devis: IDevisResponse): boolean {

   const ignoredFields: (keyof IDevisResponse)[] = [
  'demandId',
  'devisMotifRefus',
  'devisMotifRetourArriere',
  'devisDateFinTravaux',
  'devisNumeroBdc',
  'devisCommentaire'
  ];

  return Object.entries(devis)
    .filter(([key]) => !ignoredFields.includes(key as keyof IDevisResponse))
    .every(([_, value]) => value !== null && value !== undefined);
}





  sendToSncf(devis: IDevisResponse): void {
    this.dialogService.openConfirmDialog(
      'Soumettre le devis "' + (devis.devisReference ?? devis.devisId) + '" à la SNCF ?',
      'Soumettre à la SNCF'
    ).afterClosed().subscribe(res => {
      if (!res) return;

      this.devisService.updateStatut(devis.devisId, DevisStatut.EN_ATTENTE, undefined, undefined, undefined, undefined, this.authenticationService.getUser()?.profile as string ?? undefined).subscribe({
        next: () => {
          this.devisService.updateFebStatut(devis.febId, 'ATTENTEVALIDATIONSNCF').subscribe();
          this.snackbarService.openSnackBar('Devis soumis à la SNCF avec succès');
          this.loadDevis();
        },
        error: () => this.snackbarService.openSnackBar('Erreur lors de la soumission', 'error-snack-bar')
      });
    });
  }

  canArchive(devis: IDevisResponse): boolean {
    return this.authenticationService.isUserAdmin()
      && devis.devisStatut !== DevisStatut.ARCHIVE;
  }

  canDownload(devis: IDevisResponse): boolean {
    return devis.devisStatut !== DevisStatut.CREE;

  }

  archiveDevis(devis: IDevisResponse): void {
    this.dialogService.openConfirmDialog(
      'Archiver le devis "' + (devis.devisReference ?? devis.devisId) + '" ?',
      'Archiver'
    ).afterClosed().subscribe(res => {
      if (!res) return;
      this.devisService.updateStatut(devis.devisId, DevisStatut.ARCHIVE, undefined, undefined, undefined, undefined, this.authenticationService.getUser()?.profile as string ?? undefined).subscribe({
        next: () => {
          this.snackbarService.openSnackBar('Devis archivé avec succès');
          this.loadDevis();
        },
        error: () => this.snackbarService.openSnackBar('Erreur lors de l\'archivage', 'error-snack-bar')
      });
    });
  }

  canEdit(devis: IDevisResponse): boolean {
    return this.isCdcOrAdmin()
      && (devis.devisStatut === DevisStatut.CREE || devis.devisStatut === DevisStatut.REFUSE);
  }

 

async downloadDevis(devis: IDevisResponse): Promise<void> {

  this.snackbarService.openSnackBar('Génération du document en cours...');
  console.log('[downloadDevis] début pour devis', devis.devisId);

  try {
    const dateEnvoiSncf = await this.fetchDateEnvoiSncf(devis.devisId);
    console.log('[downloadDevis] dateEnvoiSncf =', dateEnvoiSncf);

    const collaborateurs = await this.fetchOrderedCollaborateurs(devis.devisId);
    console.log('[downloadDevis] collaborateurs associés =', collaborateurs);

    const cvBuffers = await this.fetchAllCvs(collaborateurs);
    console.log('[downloadDevis] CV récupérés =', cvBuffers.length);

    const devisBytes = await this.devisPdfService.generateBytes(devis, dateEnvoiSncf);
    console.log('[downloadDevis] PDF devis généré, taille =', devisBytes?.length);

    const mergedBytes = await this.devisDocumentMergeService.merge(
      [devisBytes, ...cvBuffers]
    );
    console.log('[downloadDevis] PDF fusionné, taille =', mergedBytes?.length);

    const blob = new Blob([mergedBytes as BlobPart], { type: 'application/pdf' });

    fileSaver.saveAs(
      blob,
      `Devis-${devis.devisReference ?? devis.devisId}.pdf`
    );
    console.log('[downloadDevis] saveAs appelé');

  } catch (err: any) {
    console.error('[downloadDevis] ERREUR :', err);
    this.snackbarService.openSnackBar(
      err?.message ?? 'Erreur lors de la génération du document',
      'error-snack-bar'
    );
  }
}

private fetchDateEnvoiSncf(devisId: string): Promise<string | null> {
  console.log('[fetchDateEnvoiSncf] appel pour', devisId);
  return new Promise((resolve) => {
    this.devisService.getDateEnvoiSncf(devisId).subscribe({
      next: (res) => {
        console.log('[fetchDateEnvoiSncf] réponse OK', res);
        resolve(res.dateEnvoiSncf ?? null);
      },
      error: (err) => {
        console.warn('[fetchDateEnvoiSncf] erreur (ignorée, resolve null)', err);
        resolve(null);
      }
    });
  });
}

/** Collaborateurs associés au devis, triés selon l'ordre d'affichage (CDC §8.4) */
private fetchOrderedCollaborateurs(devisId: string): Promise<IDevisCollaborateur[]> {
  console.log('[fetchOrderedCollaborateurs] appel pour', devisId);
  return new Promise((resolve, reject) => {
    this.devisCollaborateurService.getCollaborateurs(devisId).subscribe({
      next: (list) => {
        console.log('[fetchOrderedCollaborateurs] réponse OK', list);
        resolve([...list].sort((a, b) => a.ordreAffichage - b.ordreAffichage));
      },
      error: (err) => {
        console.error('[fetchOrderedCollaborateurs] ERREUR', err);
        reject(new Error('Erreur lors du chargement des collaborateurs associés au devis'));
      }
    });
  });
}

/**
 * Récupère le CV de chaque collaborateur associé, dans l'ordre.
 * CDC §8.4 : la génération doit échouer si un collaborateur associé n'a pas de CV.
 */
private async fetchAllCvs(collaborateurs: IDevisCollaborateur[]): Promise<ArrayBuffer[]> {

  console.log('[fetchAllCvs] début, nb collaborateurs =', collaborateurs.length);

  const buffers: ArrayBuffer[] = [];

  for (const c of collaborateurs) {
    try {
      console.log('[fetchAllCvs] récupération CV de', c.nom, c.prenom, c.collaborateurId);
      const blob = await this.fetchCvBlob(c.collaborateurId);
      const buf = await blob.arrayBuffer();
      console.log('[fetchAllCvs] CV OK, taille =', buf.byteLength);
      buffers.push(buf);
    } catch (err) {
      console.error('[fetchAllCvs] ERREUR pour', c.nom, c.prenom, err);
      throw new Error(
        `Impossible de générer le document : ${c.prenom} ${c.nom} n'a pas de CV enregistré.`
      );
    }
  }

  console.log('[fetchAllCvs] terminé, total =', buffers.length);
  return buffers;
}

private fetchCvBlob(collaborateurId: string): Promise<Blob> {
  return new Promise((resolve, reject) => {
    this.collaborateurService.getCvBlob(collaborateurId).subscribe({
      next: (blob) => resolve(blob),
      error: (err) => reject(err)
    });
  });
}


private formatDate(date?: string | null): string {
  if (!date) {
    return '-';
  }

  return new Date(date).toLocaleDateString('fr-FR');
}

private formatMontant(value?: number | null): string {
  return (value ?? 0).toLocaleString('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + ' €';
}

private getStatutColor(statut: DevisStatut): string {

  switch (statut) {

    case DevisStatut.ACCEPTE:
      return '#2E7D32';

    case DevisStatut.REFUSE:
      return '#C62828';

    case DevisStatut.EN_ATTENTE:
      return '#F57C00';

    case DevisStatut.ARCHIVE:
      return '#616161';

    default:
      return '#1565C0';
  }
}

  openCreateDialog(): void {
    const dialogRef = this.dialog.open(DevisCreateDialogComponent, {
      width: '860px',
      maxWidth: '98vw',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(devis => {
      if (devis) {
        this.loadDevis();
      }
    });
  }

  canValider(devis: IDevisResponse): boolean {
    return this.isAdminOrSNCF()
      && devis.devisStatut === DevisStatut.EN_ATTENTE;
  }

  canRefuser(devis: IDevisResponse): boolean {
    return this.isAdminOrSNCF()
      && devis.devisStatut === DevisStatut.EN_ATTENTE;  
  }

  canRetourArriere(devis: IDevisResponse): boolean {
    
    if (this.authenticationService.isUserAdmin()) {
      // L'admin peut remettre en CRÉÉ depuis n'importe quel statut sauf CRÉÉ
      return devis.devisStatut !== DevisStatut.CREE;
    }
    // CDC (non-admin) uniquement depuis EN_ATTENTE
    return devis.devisStatut === DevisStatut.EN_ATTENTE;
  }

  openRetourDialog(devis: IDevisResponse): void {
    const dialogRef = this.dialog.open(DevisRetourDialogComponent, {
      width: '520px',
      maxWidth: '98vw',
      data: devis
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) this.loadDevis();
    });
  }

  openValiderDialog(devis: IDevisResponse): void {
      const ref = this.dialog.open(DevisValidateDialogComponent, {
        width: '480px',
        maxWidth: '98vw',
        disableClose: true,
        data: devis
      });
      ref.afterClosed().subscribe(ok => { if (ok) this.loadDevis(); });
    }
  
    openRefuserDialog(devis: IDevisResponse): void {
      const ref = this.dialog.open(DevisRefuseDialogComponent, {
        width: '480px',
        maxWidth: '98vw',
        disableClose: true,
        data: devis
      });
      ref.afterClosed().subscribe(ok => { if (ok) this.loadDevis(); });
    }

  exportData() {
          const devisIds = this.devisList.data
            .map(devis => devis.devisId)
            .filter((id): id is string => !!id);
          if (!devisIds.length) {
            this.openErrorSnackBar('Aucun devis à exporter');
            return;
          }

          this.devisService.exportDevisData(devisIds).subscribe({
            next: (data) => {
              if (data) {
                const blob: Blob = new Blob([data], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                window.URL.createObjectURL(blob);
                fileSaver.saveAs(
                  blob,
                  'Devis - ' +
                  this.applicationSettingsService.applicationSettings.CDS_name +
                  ' - ' +
                  new Date().toLocaleDateString().replace('_', '-') +
                  ' ' +
                  new Date().toLocaleTimeString().replace('_', '-'),
                );
                this.openSuccessSnackBar('Les devis ont été exportés avec succès');
              } else {
                this.openErrorSnackBar('Aucun devis à exporter');
              }
            },
            error: (err) => {
              console.log(err);
              this.openErrorSnackBar(err?.status === 403
                ? 'Export refusé : les applications de la session ne sont pas autorisées pour ce compte.'
                : "Une erreur est survenue lors de l'export des devis");
            },
            complete: () => {
            }
          });
        }
}
